import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/aesos_logo.png';

const Navbar = () => {
  return (
    <div className="container-fluid">
      <div className="container">
        <nav className="navbar navbar-dark navbar-expand-lg py-0">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Aesos Logo" style={{ height: '50px' }} />
          </Link>

          <button
            type="button"
            className="navbar-toggler me-0  "
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            style={{background:'var(--bs-primary)'}}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse bg-transparent" id="navbarCollapse">
            <div className="navbar-nav ms-auto mx-xl-auto p-0">
              <Link to="/" className="nav-item nav-link text-secondary active">Home</Link>

              <div className="nav-item dropdown">
                <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Services</Link>
                <div className="dropdown-menu rounded">
                  <Link to="/web-devlopment" className="dropdown-item">Web Development</Link>
                  <Link to="/app-devlopment" className="dropdown-item">Mobile App Development</Link>
                </div>
              </div>

              <Link to="/projects" className="nav-item nav-link">Products</Link>
              {/* <Link to="/internship" className="nav-item nav-link">Internship</Link> */}
              <Link to="/jobs" className="nav-item nav-link">Jobs</Link>
              {/* <Link to="/verification" className="nav-item nav-link">Verification</Link> */}
              <Link to="/about" className="nav-item nav-link">About Us</Link>
              <Link to="/contact" className="nav-item nav-link">Contact Us</Link>
            </div>
          </div>

          <div className="d-none d-xl-flex flex-shrink-0">
            <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
              <a href="tel:+919277005656" className="position-relative animated tada infinite">
                <i className="fa fa-phone-alt text-black fa-2x"></i>
                <div className="position-absolute" style={{ top: '-7px', left: '20px' }}>
                  <span><i className="fa fa-comment-dots text-secondary"></i></span>
                </div>
              </a>
            </div>

            <div className="d-flex flex-column pe-4 border-end">
              <span className="text-black">Have any questions?</span>
              <span className="text-secondary">Call: +91 9277005656</span>
            </div>

            <div className="d-flex align-items-center justify-content-center ms-4">
              <Link to="#"><i className="bi bi-search text-white fa-2x"></i></Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
